import classNames from "classnames";

import { convertUnderlineToSpace } from "@ascendnow/shared";

import AscLink from "../../AscLink/AscLink";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscMyApplicationsCard.module.scss";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import { CalendarEmptyIcon } from "../../AscIcons";

export interface AscMyApplicationsCardProps {
  loading?: boolean;
  applications?: {
    id: string;
    job: {
      company: {
        id: string;
        title: string;
        logo: {
          location: string;
        };
      };
      jobCategory: string;
    };
  }[];
  className?: string;
  onClick?: () => void;
  path: string;
}

export default function AscMyApplicationsCard({
  applications,
  className,
  loading = false,
  path,
}: AscMyApplicationsCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={
        <div className={styles.cardTitle}>
          <h5 className={classNames(styles.titleText)}>My Applications</h5>
          <AscLink
            className={styles.link}
            showIcon
            href={path}
            innerWrapperTag="button"
          >
            See all
          </AscLink>
        </div>
      }
      coverImageUrl={null}
      loading={loading}
    >
      {applications?.map((application, index) => (
        <>
          <div key={application?.id} className={styles.applicationItem}>
            <img
              className={styles.logo}
              alt={application.job.company.title}
              src={application.job.company.logo.location}
            />
            <div className={styles.right}>
              <AscParagraph className={styles.company}>
                {application?.job?.company.title}
              </AscParagraph>
              <div className={styles.bottom}>
                <CalendarEmptyIcon className={styles.icon} />
                {application?.job?.jobCategory && (
                  <AscParagraph className={styles.type}>
                    {convertUnderlineToSpace(application?.job?.jobCategory)}
                  </AscParagraph>
                )}
              </div>
            </div>
          </div>
          {applications.length - 1 !== index && (
            <div className={styles.divider} />
          )}
        </>
      ))}
    </AscGenericCard>
  );
}
